import * as yup from "yup";
import type { IGraphicsPayload } from "../types/matchDetails.d";

export const graphicsSchema: yup.ObjectSchema<IGraphicsPayload> = yup
  .object({
    divisionId: yup.string().default("").optional(),
    inningId: yup.string().default("").optional(),
    playerId: yup.string().default("").optional(),

    matchId: yup
      .string()
      .trim()
      .required("Match ID is required"),

    graphicsType: yup
      .string()
      .trim()
      .required("Select a graphics type"),
  })
  .required();